<template>
  <form class="nameform" @submit="next">
    <div class="content content--small">
      <p class="text-grey text-center mb-5">Di cosa ti occupi?</p>

      <div class="w-full mb-6">
        <div class="tnb-input" :class="{ error: $v.gianos.job.$error }">
          <label for="job">Professione</label>
          <select
            v-model.trim="$v.gianos.job.$model"
            @change="onChangeJobHandler"
            class="tnb-select"
            id="job"
          >
            <option></option>
            <option
              v-for="domain in sort(jobsList, 'description')"
              :value="domain.code"
              :key="domain.code"
              >{{ domain.description }}</option
            >
          </select>

          <ValidationText :value="$v.gianos.job" />
        </div>
      </div>
      <transition name="fade">
        <div v-show="gianos.job && !isUnemployed" class="w-full mb-6">
          <div
            class="tnb-input"
            :class="{ error: $v.gianos.activitySector.$error }"
          >
            <label for="activitySector">In che settore lavori?</label>
            <select
              v-model.trim="$v.gianos.activitySector.$model"
              class="tnb-select"
              id="activitySector"
            >
              <option></option>
              <option
                v-for="domain in sort(sectorActivities, 'description')"
                :value="domain.code"
                :key="domain.code"
                >{{ domain.description }}</option
              >
            </select>

            <ValidationText :value="$v.gianos.activitySector" />
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-show="gianos.activitySector && !isUnemployed"
          class="w-full mb-6"
        >
          <div class="tnb-input" :class="{ error: $v.gianos.activity.$error }">
            <label for="activity">Area di attività</label>
            <select
              v-model.trim="$v.gianos.activity.$model"
              class="tnb-select"
              id="activity"
            >
              <option></option>
              <option
                v-for="domain in sort(economicActivities, 'description')"
                :value="domain.code"
                :key="domain.code"
                >{{ domain.description }}</option
              >
            </select>

            <ValidationText :value="$v.gianos.activity" />
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div
          v-show="
            isImprenditoreOrSoggettoApicale &&
              gianos.activitySector &&
              gianos.activity
          "
          class="w-full mb-6"
        >
          <div class="tnb-input" :class="{ error: $v.gianos.legalType.$error }">
            <label for="legalType">Natura giuridica</label>
            <select
              v-model.trim="$v.gianos.legalType.$model"
              class="tnb-select"
              id="legalType"
            >
              <option></option>
              <option
                v-for="domain in sort(legalTypeList, 'description')"
                :value="domain.code"
                :key="domain.code"
                >{{ domain.description }}</option
              >
            </select>

            <ValidationText :value="$v.gianos.legalType" />
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-show="gianos.job && !isUnemployed" class="w-full mb-6">
          <div
            class="tnb-input"
            :class="{ error: $v.gianos.activityCountry.$error }"
          >
            <label for="activityCountry">Stato</label>
            <select
              v-model.trim="$v.gianos.activityCountry.$model"
              class="tnb-select"
              id="activityCountry"
              @change="
                () => {
                  gianos.activityProvince = '';
                }
              "
            >
              <option></option>
              <option value="I">Italia</option>
              <option
                v-for="country in countries"
                v-bind:value="country.code"
                v-bind:key="country.code"
              >
                {{
                  country.name.charAt(0).toUpperCase() +
                    country.name.toLowerCase().slice(1)
                }}
              </option>
            </select>

            <ValidationText :value="$v.gianos.activityCountry" />
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-show="gianos.activityCountry === 'I'" class="w-full mb-6">
          <div
            class="tnb-input"
            :class="{ error: $v.gianos.activityProvince.$error }"
          >
            <label for="activityProvince">Provincia</label>
            <select
              v-model.trim="$v.gianos.activityProvince.$model"
              class="tnb-select"
              id="activityProvince"
            >
              <option></option>
              <option
                v-for="province in provinces"
                v-bind:value="province"
                v-bind:key="province"
              >
                {{ province }}
              </option>
            </select>
            <ValidationText :value="$v.gianos.activityProvince" />
          </div>
        </div>
      </transition>

      <div class="w-full mb-6">
        <div class="tnb-input tnb-radio flex-col">
          <label for="sensitiveSectors"
            >Sei attivo in settori o paesi sensibili?</label
          >
          <span
            class="f-m text-grey label-info "
            @click="showModalSensitiveSectors"
            >Perchè mi chiedi questo?</span
          >
          <div>
            <div class="tnb-radio-container mr-8">
              <input
                v-model="gianos.sensitiveSectors"
                type="radio"
                id="yes"
                name="sensitiveSectors"
                @click="showModalConfirmSensitiveSectors"
                :value="true"
              />
              <label for="yes">Si</label>
            </div>
            <div class="tnb-radio-container">
              <input
                v-model="gianos.sensitiveSectors"
                type="radio"
                id="no"
                name="sensitiveSectors"
                :value="false"
              />
              <label for="no">No</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
      <div class="flex flex-wrap my-6">
        <div class="row-switch w-full mb-6">
          <p class="f-b">
            Dichiaro di non essere attivo in settori o paesi sensibili.
          </p>
          <label class="switch">
            <input v-model="gianos.sensitiveSectors" type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div> -->
    <div class="page-footer">
      <button class="btn" :disabled="$v.$invalid" type="submit">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { /* sameAs, */ required, requiredIf } from "vuelidate/lib/validators";
import ValidationText from "@/components/ValidationText";
import DocumentsService from "@/services/DocumentsService";
import LookupsService from "@/services/LookupsService";
import UtilityService from "@/services/UtilityService";
import ApiService from "@/services/ApiService";

export default {
  name: "Gianos",
  components: {
    ValidationText
  },
  data() {
    return {
      gianos: {
        sensitiveSectors: null,
        job: null,
        activitySector: null,
        activity: null,
        activityCountry: null,
        activityProvince: null,
        legalType: null,
      },

      activities: [],
      domains: [],
      countries: [],
      provinces: [],
      constants: {
        jobs: {
          IMPRENDITORE: "01",
          LAVORATORE_AUTONOMO: "02",
          LIBERO_PROFESSIONISTA: "03",
          LAVORATORE_DIPENDENTE: "04",
          SOGGETTO_APICALE: "05",
          PENSIONATO: "06",
          NON_OCCUPATO: "07",
          CASALINGA: "08",
          STUDENTE: "09"
        },
        sensitiveCountries: ""
      }
    };
  },
  computed: {
    jobsList: function() {
      return this.domains.filter(d => d.field === "PROFESSIONE");
    },
    sectorActivities: function() {
      return this.domains.filter(
        d => d.field === "SETTORE_ATTIVITA" && d.flow === "L2"
      );
    },
    legalTypeList: function() {
      return this.domains.filter(a => a.field === "FORMA_GIURIDICA_SOCIETA");
    },
    economicActivities: function() {
      return this.activities.filter(
        a => a.sectorCode === this.gianos.activitySector
      );
    },

    isImprenditoreOrSoggettoApicale: function() {
      return (
        this.gianos.job === this.constants.jobs.IMPRENDITORE ||
        this.gianos.job === this.constants.jobs.SOGGETTO_APICALE
      );
    },
    isUnemployed: function() {
      return (
        this.gianos.job === this.constants.jobs.NON_OCCUPATO ||
        this.gianos.job === this.constants.jobs.STUDENTE ||
        this.gianos.job === this.constants.jobs.PENSIONATO ||
        this.gianos.job === this.constants.jobs.CASALINGA
      );
    }
  },
  validations: {
    gianos: {
      sensitiveSectors: { required },
      job: {
        required
      },
      activitySector: {
        required: requiredIf(function() {
          return !this.isUnemployed;
        })
      },
      activity: {
        required: requiredIf(function() {
          return !this.isUnemployed;
        })
      },
      legalType: {
        required: requiredIf(function() {
          return this.isImprenditoreOrSoggettoApicale;
        })
      },
      activityCountry: {
        required: requiredIf(function() {
          return !this.isUnemployed;
        })
      },
      activityProvince: {
        required: requiredIf(function() {
          return this.gianos.activityCountry === "I" && !this.isUnemployed;
        })
      }
    }
  },
  mounted() {
    DocumentsService.getGianos().then(response => {
      this.activities = response.data.activities;
      this.domains = response.data.domains;
      this.fillUpInfoFromStore();
    });

    LookupsService.getCountries().then(response => {
      this.countries = response.data.countries;
    });
    const skipAbolishedProvinces = true;
    LookupsService.getProvinces(skipAbolishedProvinces).then(response => {
      this.provinces = response.data.provinces;
    });

    this.getSensitiveCountries();

    window.moreDetails = this.moreDetails;
  },
  methods: {
    fillUpInfoFromStore() {
      const gianos = this.$store.state.user?.details?.gianos?.pop();
      if (!gianos) return;

      this.gianos.sensitiveSectors = gianos.sensitiveSectors;
      this.gianos.job = gianos.job;
      this.gianos.activitySector = gianos.activitySector;
      this.gianos.activity = gianos.activity;
      this.gianos.activityCountry = gianos.activityCountry;
      this.gianos.activityProvince = gianos.activityProvince;
      this.gianos.legalType = gianos.legalType;
    },
    sort(list, orderBy) {
      return UtilityService.sort(list, orderBy);
    },
    showModalSensitiveSectors() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Definizione",
        htmlMessage: `<b>Elenco Settori sensibili</b>: produzione e commercio in arte e preziosi, costruzione e commercio di armi, cariche pubbliche, smaltimento di rifiuti, case da gioco, fondazioni/associazioni a scopo caritatevole, fondazioni/organizzazioni/ associazioni a scopo religioso, energia, sanità;<br><br>
                      <b>Elenco Paesi sensibili</b>: <br>${this.sensitiveCountries}<br><br>`
      });
    },
    showModalConfirmSensitiveSectors() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Attenzione",
        htmlMessage: `

        <p>Hai indicato di essere <b>attivo in settori o paesi sensibili</b>, questo comporterà un prolungarsi dei tempi di gestione della tua registrazione.
        <br><br> Sei sicuro di lavorare in uno di questi settori?</p>

        <ul style="padding: 10px; margin: 0 0 0 15px; list-style: disc;">
          <li>arte e preziosi</li>
          <li>lavori pubblici (come ad esempio gare, appalti..)</li>
          <li>smaltimento di rifiuti</li>
          <li>case da gioco</li>
          <li>fondazioni/associazioni</li>
        </ul>

        <p>
          In caso contrario seleziona NO alla domanda "Sei attivo in settori o paesi sensibili?".
          <br> <br>Per maggiori dettagli e per visualizzare la lista dei Paesi sensibili, <span class="link" onclick="moreDetails()">clicca qui</span>.
        </p><br><br>`
      });
    },
    async getSensitiveCountries() {
      try {
        const r = await ApiService.get("/utl/v2/contents/onboardingConfig");
        this.sensitiveCountries = r?.data[0]?.sensitiveCountries || "";
      } catch (error) {
        console.log(error);
      }
    },
    moreDetails() {
      this.$root.$emit("closeModal", "genericModal")
      this.showModalSensitiveSectors();
    },

    onChangeJobHandler() {
      this.gianos.activitySector = "";
      this.gianos.activity = "";
      this.gianos.legalType = "";
      this.gianos.activityCountry = "";
      this.gianos.activityProvince = "";
    },
    next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      this.gianos = this.removeEmptyValues(this.gianos);
      this.$store.commit("setUser", {
        gianos: this.gianos
      });
      this.$root.$emit("submitStep");
    },

    removeEmptyValues(obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] === "" || obj[key] === null) delete obj[key];
      });
      return obj;
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-app .tnb-radio > label {
  width: 100%;
}
</style>
